<app-loading *ngIf="contentReady"></app-loading>

<div class="container-fluid mb-4" style='margin-top:60px'>
  <div class="row additem-content">
    <!-- Header -->
    <h2 class="additemhead">السليدر</h2>

    <form [formGroup]="notificationForm" (ngSubmit)="addNotification()" enctype="multipart/form-data">
      <div class="form-container">

        <!-- Arabic & English Titles -->
        <div class="form-row">
          <div class="form-group">
            <label class="label" for="notification_head_ar">العنوان بالعربية</label>
            <input class="input" id="notification_head_ar" type="text" formControlName="notification_head_ar"
              placeholder="العنوان بالعربية" [ngClass]="{
                'is-invalid': notificationForm.get('notification_head_ar')?.touched && notificationForm.get('notification_head_ar')?.invalid,
                'is-valid': notificationForm.get('notification_head_ar')?.touched && notificationForm.get('notification_head_ar')?.valid
              }">
          </div>

          <div class="form-group">
            <label class="label" for="notification_head_en">العنوان بالإنجليزية</label>
            <input class="input" id="notification_head_en" type="text" formControlName="notification_head_en"
              placeholder="العنوان بالإنجليزية" [ngClass]="{
                'is-invalid': notificationForm.get('notification_head_en')?.touched && notificationForm.get('notification_head_en')?.invalid,
                'is-valid': notificationForm.get('notification_head_en')?.touched && notificationForm.get('notification_head_en')?.valid
              }">
          </div>
        </div>

        <!-- Arabic & English Body -->
        <div class="form-row">
          <div class="form-group">
            <label class="label" for="notification_body_ar"> المحتوى بالعربية</label>
            <textarea class="input" id="notification_body_ar" rows="3" formControlName="notification_body_ar"
              placeholder="المحتوى بالعربية" [ngClass]="{
                'is-invalid': notificationForm.get('notification_body_ar')?.touched && notificationForm.get('notification_body_ar')?.invalid,
                'is-valid': notificationForm.get('notification_body_ar')?.touched && notificationForm.get('notification_body_ar')?.valid
              }"></textarea>
          </div>

          <div class="form-group">
            <label class="label" for="notification_body_en"> المحتوى بالإنجليزية</label>
            <textarea class="input" id="notification_body_en" rows="3" formControlName="notification_body_en"
              placeholder="المحتوى بالإنجليزية" [ngClass]="{
                'is-invalid': notificationForm.get('notification_body_en')?.touched && notificationForm.get('notification_body_en')?.invalid,
                'is-valid': notificationForm.get('notification_body_en')?.touched && notificationForm.get('notification_body_en')?.valid
              }"></textarea>
          </div>
        </div>

        <!-- Image Uploads -->
        <div class="form-row">
          <!-- Desktop Image -->
          <div class="form-group">
            <label class="label">رفع صورة</label>
            <div class="upload-card" (click)="desktopFileInput.click()">
              <input type="file" #desktopFileInput hidden accept="image/*" (change)="onFileSelected($event)" />

              <div *ngIf="!desktopPreview" class="upload-placeholder">
                <span class="upload-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="7" width="18" height="14" rx="3" stroke="#4a792b" stroke-width="2.5" />
                    <circle cx="12" cy="14" r="3.5" stroke="#4a792b" stroke-width="2.5" />
                    <path d="M8 7L9.5 5H14.5L16 7" stroke="#4a792b" stroke-width="2.5" />
                  </svg>
                </span>
                <p class="upload-text">رفع صورة سطح المكتب</p>
                <small class="upload-sub">PNG / JPG</small>
              </div>

              <div *ngIf="desktopPreview" class="preview-container">
                <img [src]="desktopPreview" class="preview-img" />
                <button type="button" class="change-btn" (click)="desktopFileInput.click(); $event.stopPropagation()">
                  {{ 'Change image' | translate }}
                </button>
              </div>
            </div>
          </div>

          <!-- Mobile Image -->
          <div class="form-group">
            <label class="label">صورة الهاتف</label>
            <div class="upload-card" (click)="mobileFileInput.click()">
              <input type="file" #mobileFileInput hidden accept="image/*" (change)="onMobileImageSelected($event)" />

              <div *ngIf="!mobilePreview" class="upload-placeholder">
                <span class="upload-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="7" width="18" height="14" rx="3" stroke="#4a792b" stroke-width="2.5" />
                    <circle cx="12" cy="14" r="3.5" stroke="#4a792b" stroke-width="2.5" />
                    <path d="M8 7L9.5 5H14.5L16 7" stroke="#4a792b" stroke-width="2.5" />
                  </svg>
                </span>
                <p class="upload-text">رفع صورة الهاتف</p>
                <small class="upload-sub">PNG / JPG</small>
              </div>

              <div *ngIf="mobilePreview" class="preview-container">
                <img [src]="mobilePreview" class="preview-img" />
                <button type="button" class="change-btn" (click)="mobileFileInput.click(); $event.stopPropagation()">
                غير الصورة
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Link & Submit -->
        <div class="form-row">
          <div class="form-group">
            <label class="label" for="link">الرابط </label>
            <input class="input" id="link" type="url" formControlName="link" placeholder="https://example.com"
              [ngClass]="{
                'is-invalid': notificationForm.get('link')?.touched && notificationForm.get('link')?.invalid,
                'is-valid': notificationForm.get('link')?.touched && notificationForm.get('link')?.valid
              }">
          </div>

          <div class="form-group submit-group">
            <button class="submit-btn" type="submit" [disabled]="notificationForm.invalid">
              {{ 'Submit' | translate }}
            </button>
          </div>
        </div>

      </div>
    </form>

    <!-- Table Section -->
    <div class="form-container" style="margin-top: 40px;">
      <div class="form-group products-table-group">
        <label class="label">قائمة الصور</label>

        <div class="table-responsive">
          <table class="table table-custom">
            <thead>
              <tr>
                <th>العنوان بالعربية</th>
                <th>العنوان بالإنجليزية</th>
                <th>المحتوى (العربية)</th>
                <th>المحتوى (الإنجليزية)</th>
                <th>الرابط</th>
                <th style="text-align: center;">خيارات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of dataSource.data">
                <td>{{ element.notification_head_ar }}</td>
                <td>{{ element.notification_head_en }}</td>
                <td>{{ element.notification_body_ar | slice:0:50 }}{{ element.notification_body_ar?.length > 50 ? '...'
                  : '' }}</td>
                <td>{{ element.notification_body_en | slice:0:50 }}{{ element.notification_body_en?.length > 50 ? '...'
                  : '' }}</td>
                <td>
                  <a *ngIf="element.link" [href]="element.link" target="_blank" class="text-truncate d-inline-block"
                    style="max-width: 150px;">
                    {{ element.link }}
                  </a>
                  <span *ngIf="!element.link">-</span>
                </td>
                <td style="text-align: center;">
                  <button class="tag-remove"
                    style="background: #ffebee; color: #dc3545; width: auto; padding: 4px 12px; border-radius: 6px;"
                    (click)="deleteItem(element.id)">
                    {{ 'Delete' | translate }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No Data State -->
        <div *ngIf="noData" class="text-center py-5">
          <app-nodata></app-nodata>
        </div>

      </div>
    </div>

  </div>
</div>
